<template>
  <b-tab class="border-0">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.product.category') }}</span>
    </template>

    <McEditableTable
      v-show="isTableDataAvailable"
      ref="table"
      searchable
      hasEmit:submitError
      :fields="fields"
      :apiClient="apiClient"
      :apiErrorMappings="productCategoryApiErrorMappings"
      @available-change="handleDataAvailable"
      @submitError="handleSubmitError"
    >
      <template #box_type_ids="{ item }">
        <McChipList
          v-if="item?.box_types && item?.box_types?.length"
          :items="item.box_types"
          :max-visible="3"
          itemTextField="name"
          showAllMode="dropdown"
          :showAllDropdownTitle="$t('setting.list.product.field.boxType')"
          showAllDropdownTrigger="action"
        />
        <span v-else>-</span>
      </template>
    </McEditableTable>
    <div v-show="!isTableDataAvailable" class="empty-table-container">
      <img :src="illustrationPath" alt />
      <strong>{{ $t('setting.list.product.emptyCategory') }}</strong>
      <p>{{ $t('setting.list.product.add') }}</p>
      <b-button variant="primary" @click="handleAdd">
        <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
      </b-button>
    </div>
  </b-tab>
</template>

<script>
import { mapGetters } from 'vuex'

import McEditableTable from '@/components/McEditableTable'
import McChipList from '@/components/McChipList'

import productCategoryFields from './lib/fields/productCategoryFields'
import productCategoryApiErrorMappings from './lib/constants/product-category-api-error-mappings'

import * as ProductCategory from '@/services/rest-api/lib/product/product-category'

// TODO: add unit test to this component on integration ticket
export default {
  components: {
    McEditableTable,
    McChipList,
  },
  data() {
    return {
      isTableDataAvailable: true,
      productCategoryApiErrorMappings: productCategoryApiErrorMappings,
    }
  },
  computed: {
    fields() {
      return productCategoryFields
    },
    apiClient() {
      return {
        get: ProductCategory.get,
        store: ProductCategory.store,
        show: async (opts) => {
          const res = await ProductCategory.show(opts)

          return {
            data: {
              ...res.data,
              box_type_ids: res.data?.box_types?.map((box_type) => box_type?.id),
            }
          }
        },
        update: ProductCategory.update,
        delete: ProductCategory.deleteSingle,
      }
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),

    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      this.$refs.table.handleAdd()
    },
    handleSubmitError(data) {
      // TODO: Could be enhanced to handle the other error cases
      if (data.errors && data.status == 400) {
        if (data.errors.name && data.errors.name[0] == 'value is not unique') {
          this.$mcToast.error('Gagal simpan. Kategori Produk sudah terdaftar di sistem.')
          return
        }

        this.$mcToast.error('Terdapat kesalahan format pada input anda')
      }
    },
  },
}
</script>
